import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';

const routes: Routes = [
    {path: RouteNames.BASE, component: DownloadsComponent}
];


@NgModule({
    declarations: [
        DownloadsComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class DownloadsModule {
}
